import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "../axios";

export default function DepotListPage({ showTitle = true }) {
  const [depots, setDepots] = useState([]);

  useEffect(() => {
    axios
      .get("/depots")
      .then((res) => setDepots(res.data))
      .catch((err) => console.error("営業所取得エラー:", err));
  }, []);

  return (
    <div style={{ maxWidth: "960px", margin: "0 auto", padding: "0 0 12px" }}>
      {showTitle && (
        <div style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "16px",
          padding: "11px 16px 11px 18px",
          borderLeft: "4px solid #047857",
          borderRadius: "0 8px 8px 0",
          background: "linear-gradient(90deg, #ecfdf5 0%, #f8fffe 70%, #fff 100%)",
          boxShadow: "0 1px 4px rgba(4,120,87,0.08)",
        }}>
          <span style={{ fontSize: "1rem", fontWeight: "700", color: "#065f46", letterSpacing: "0.05em" }}>
            営業所一覧
          </span>
          <span style={{ fontSize: "10px", fontWeight: "700", color: "#6ee7b7", letterSpacing: "0.15em" }}>
            DEPOT
          </span>
        </div>
      )}

      <div className="depot-grid">
        {depots.map((depot) => (
          <Link
            key={depot.id}
            to={`/depots/${encodeURIComponent(depot.short_name)}`}
            style={{ textDecoration: "none" }}
          >
            <div
              className="depot-card"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "13px 14px",
                background: "linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%)",
                border: "1.5px solid #6ee7b7",
                borderRadius: "12px",
                boxShadow: "0 2px 6px rgba(4,120,87,0.08)",
                transition: "all 0.18s ease",
                cursor: "pointer",
              }}
            >
              <span style={{
                fontSize: "16px",
                fontWeight: "700",
                color: "#065f46",
                letterSpacing: "0.04em",
              }}>
                {depot.short_name}
              </span>
              <span style={{
                fontSize: "18px",
                color: "#6ee7b7",
                fontWeight: "700",
                lineHeight: 1,
              }}>
                ›
              </span>
            </div>
          </Link>
        ))}
        {/* 廃車車両: 全営業所の廃車車両を過去データの画面で 1 つの表に（直近 8 日の表には廃車車両が出ない） */}
        <Link to="/archive?retired=1&list=1" style={{ textDecoration: "none" }}>
          <div
            className="depot-card depot-card--retired"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "13px 14px",
              background: "linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%)",
              border: "1.5px solid #d1d5db",
              borderRadius: "12px",
              boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
              transition: "all 0.18s ease",
              cursor: "pointer",
            }}
          >
            <span style={{ fontSize: "16px", fontWeight: "700", color: "#4b5563", letterSpacing: "0.04em" }}>
              廃車車両
            </span>
            <span style={{ fontSize: "18px", color: "#9ca3af", fontWeight: "700", lineHeight: 1 }}>›</span>
          </div>
        </Link>
      </div>

      <style>{`
        .depot-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 10px;
        }
        @media (min-width: 480px) {
          .depot-grid { grid-template-columns: repeat(3, 1fr); }
        }
        @media (min-width: 768px) {
          .depot-grid { grid-template-columns: repeat(4, 1fr); }
        }
        .depot-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 16px rgba(4,120,87,0.18) !important;
          background: linear-gradient(135deg, #a7f3d0 0%, #6ee7b7 100%) !important;
        }
        .depot-card--retired:hover {
          box-shadow: 0 6px 16px rgba(0,0,0,0.12) !important;
          background: linear-gradient(135deg, #e5e7eb 0%, #d1d5db 100%) !important;
        }
      `}</style>
    </div>
  );
}
